import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

// Constants
import { DropdownPlacement } from '../dropdown/WpDropdownMenu';

// Components
import WpTextField from '../text-field/WpTextField';
import { WpDropdown, WpDropdownToggle, WpDropdownMenu, WpDropdownMenuItem, WidthType } from '../dropdown';

// Styles
import './WpTimeInput.scss';

export interface Props {
  /** ID for the input */
  id: string;
  /** Label for the input */
  label: string;
  /** Hide the label, but keep on screen for screen readers */
  labelHidden?: boolean;
  /** Disable the input */
  disabled?: boolean;
  /** Additional hint text to display */
  helpText?: React.ReactNode;
  /** Callback when value is changed */
  onChange?(value: string): void;
  /** Callback when input is focused */
  onFocus?(): void;
  /** Callback when focus is removed */
  onBlur?(): void;
  /** Initial value for the input - Unix timestamp*/
  value?: string;
  required?: boolean;
  /** Error to display beneath the label */
  error?: string;
  /** Automatically focus the input */
  autoFocus?: boolean;
  placeholder?: string;
  showRequiredIndicator?: boolean;
  placement?: DropdownPlacement;
}

const WpTimeInput: React.FC<Props> = ({
  id,
  label,
  labelHidden,
  disabled,
  helpText,
  onChange,
  onFocus,
  onBlur,
  value,
  required,
  placeholder = '',
  error,
  autoFocus,
  showRequiredIndicator = true,
  placement,
}: Props) => {
  const [selectedTime, setSelectedTime] = useState('');

  const hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
  const minutes = ['00', '15', '30', '45'];
  const ampm = ['am', 'pm'];

  const handleTimeSelect = time => {
    if (onChange) onChange(time);
    setSelectedTime(time);
  };

  const buildTimeOptions = () => {
    return ampm.map(ap => {
      return hours.map(hour => {
        return minutes.map(minute => {
          return (
            <WpDropdownMenuItem
              onClick={() => handleTimeSelect(`${hour}:${minute} ${ap}`)}
            >{`${hour}:${minute} ${ap}`}</WpDropdownMenuItem>
          );
        });
      });
    });
  };

  const classNamePrefix = 'WpTimeInput';
  const classes = classnames(classNamePrefix);

  useEffect(() => {
    if (value) setSelectedTime(value);
  }, []);

  return (
    <div className={classes}>
      <WpDropdown placement={placement}>
        <WpDropdownToggle>
          <WpTextField
            id={id}
            label={label}
            labelHidden={labelHidden}
            disabled={disabled}
            placeholder={placeholder}
            error={error}
            autoFocus={autoFocus}
            onFocus={onFocus}
            onBlur={onBlur}
            readOnly
            type="text"
            required={required}
            helpText={helpText}
            value={selectedTime}
            prefixIcon="clock"
            showRequiredIndicator={showRequiredIndicator}
          />
        </WpDropdownToggle>
        <WpDropdownMenu width={WidthType.target}>
          {buildTimeOptions()}
          {/* <WpDropdownMenuItem removeBackgroundHover>time input here</WpDropdownMenuItem> */}
        </WpDropdownMenu>
      </WpDropdown>

      {/* <input type="time"/> */}
    </div>
  );
};

export default WpTimeInput;
